import { h } from '..//index.js';
export const selectCaseUpdates = (state, caseId) => {
    const updates = state.caseUpdates[caseId];
    if (!h.hasData(updates)) {
        return null;
    }
    return updates.data;
};
export const selectCaseSatisfactions = (state, id) => {
    const satisfactions = state.caseSatisfactions[id];
    if (!h.hasData(satisfactions)) {
        return null;
    }
    return satisfactions.data;
};
//# sourceMappingURL=selectors.js.map